export default {
  edit_info_modal: {
    header_title: 'Setting Profile.',
    desc_title: 'Manage customer profile data for in-depth analysis.',
    header_name: 'Topic Name',
    header_name_required: 'Please enter a group name.',
  },
};
